<script>
import MetisMenu from 'metismenujs/dist/metismenujs';

import { menuItems } from './menu';

/**
 * Sidenav component
 */
export default {
  data() {
    return {
      menuItems: menuItems,
      menuData: null,
      notifInterval: null,
    };
  },
  beforeDestroy() {
    clearInterval(this.notifInterval);
  },
  mounted: function () {
    // eslint-disable-next-line no-unused-vars
    let menuRef = new MetisMenu('#side-menu');
    let links = document.getElementsByClassName('side-nav-link-ref');
    let matchingMenuItem = null;
    const paths = [];

    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]['pathname']);
    }
    let itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      matchingMenuItem = links[paths.indexOf(item)];
    } else {
      matchingMenuItem = links[itemIndex];
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add('active');
      let parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add('mm-active');
        const parent2 = parent.parentElement.closest('ul');
        if (
          parent2 &&
          parent2.id !== 'side-menu' &&
          !parent2.classList.contains('always-expanded')
        ) {
          parent2.classList.add('mm-show');

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add('mm-active');

            const parent4 = parent3.parentElement;
            if (parent4 && parent4.id !== 'side-menu') {
              parent4.classList.add('mm-show');
              const parent5 = parent4.parentElement;
              if (parent5 && parent5.id !== 'side-menu') {
                parent5.classList.add('mm-active');
                const childanchor = parent5.querySelector('.is-parent');
                if (childanchor && parent5.id !== 'side-menu') {
                  childanchor.classList.add('mm-active');
                }
              }
            }
          }
        }
      }
    }

    //Notifications
    let self = this;
    this.notifInterval = setInterval(function () {
      self.$store.dispatch('cache/fetchAlerts');
    }, 12000);
  },
  methods: {
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },

    toggleMenu(event) {
      event.currentTarget.nextElementSibling.classList.toggle('mm-show');
    },
  },
  computed: {
    userConfig() {
      return this.$store.state.user.config;
    },
    alerts() {
      return this.$store.state.cache.alerts;
    },
    isMenuCondensed() {
      return this.$store.state.layout.menuCondensed;
    },
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <template v-if="userConfig != null">
        <template v-for="item in menuItems">
          <template
            v-if="
              !item.role ||
              (item.adminAccess && userConfig.isAdmin) ||
              userConfig.permissions[item.role]
            "
          >
            <!-- ALWAYS EXPANDED VERSION -->
            <li v-if="item.alwaysExpanded && !isMenuCondensed" :key="item.id">
              <a
                v-if="hasItems(item)"
                href="javascript:void(0);"
                class="is-parent override-parent always-expanded"
                :class="{
                  'has-dropdown': item.badge,
                }"
              >
                <i :class="item.icon" v-if="item.icon && isMenuCondensed"></i>
                <span>{{ $t(item.label) }}</span>
              </a>
              <div v-if="hasItems(item)" class="sub-menu">
                <template v-for="(subitem, index) of item.subItems">
                  <li
                    v-if="
                      !subitem.role ||
                      (subitem.adminAccess && userConfig.isAdmin) ||
                      userConfig.permissions[subitem.role]
                    "
                    :key="index"
                    class="custom-sub-menu"
                  >
                    <router-link
                      :to="subitem.link"
                      v-if="!hasItems(subitem)"
                      class="side-nav-link-ref"
                    >
                      {{ $t(subitem.label) }}
                      <span
                        v-if="
                          alerts != null &&
                          subitem.alertsCode != undefined &&
                          alerts[subitem.alertsCode] > 0
                        "
                        class="badge badge-danger pt-1 pb-1"
                        style="
                          margin-left: 5px;
                          font-size: 0.8em;
                          min-width: 20px;
                        "
                        >{{ alerts[subitem.alertsCode] }}</span
                      >
                    </router-link>
                  </li>
                </template>
              </div>
            </li>

            <!-- COLLAPSED VERSION -->
            <li v-else :key="item.id">
              <a
                v-if="hasItems(item)"
                href="javascript:void(0);"
                class="is-parent override-parent"
                :class="{
                  'has-arrow': !item.badge,
                  'has-dropdown': item.badge,
                }"
              >
                <i :class="item.icon" v-if="item.icon && isMenuCondensed"></i>
                <span>{{ $t(item.label) }}</span>
                <span
                  :class="`badge badge-pill badge-${item.badge.variant} float-right`"
                  v-if="item.badge"
                  >{{ $t(item.badge.text) }}</span
                >
              </a>
              <router-link
                :to="item.link"
                v-if="!hasItems(item)"
                class="side-nav-link-ref"
              >
                <i :class="item.icon" v-if="item.icon"></i>
                <span v-if="!item.icon" style="margin-left: 28px"></span>
                <span>{{ $t(item.label) }}</span>
                <span
                  :class="`badge badge-pill badge-${item.badge.variant} float-right`"
                  v-if="item.badge"
                  >{{ $t(item.badge.text) }}
                </span>
              </router-link>
              <ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false">
                <template v-for="(subitem, index) of item.subItems">
                  <li
                    v-if="
                      !subitem.role ||
                      (subitem.adminAccess && userConfig.isAdmin) ||
                      userConfig.permissions[subitem.role]
                    "
                    :key="index"
                  >
                    <router-link
                      :to="subitem.link"
                      v-if="!hasItems(subitem)"
                      class="side-nav-link-ref"
                    >
                      {{ $t(subitem.label) }}

                      <span
                        v-if="
                          alerts != null &&
                          subitem.alertsCode != undefined &&
                          alerts[subitem.alertsCode] > 0
                        "
                        class="badge badge-danger pt-1 pb-1"
                        style="
                          margin-left: 5px;
                          font-size: 0.8em;
                          min-width: 20px;
                          display: inline-block !important;
                        "
                        >{{ alerts[subitem.alertsCode] }}</span
                      >
                    </router-link>
                    <a
                      v-if="hasItems(subitem)"
                      class="side-nav-link-a-ref has-arrow"
                      href="javascript:void(0);"
                      >{{ $t(subitem.label) }}</a
                    >
                    <ul
                      v-if="hasItems(subitem)"
                      class="sub-menu mm-collapse"
                      aria-expanded="false"
                    >
                      <li
                        v-for="(subSubitem, index) of subitem.subItems"
                        :key="index"
                      >
                        <router-link
                          :to="subSubitem.link"
                          class="side-nav-link-ref"
                        >
                          {{ $t(subSubitem.label) }}
                        </router-link>
                      </li>
                    </ul>
                  </li>
                </template>
              </ul>
            </li>
          </template>
        </template>
      </template>
    </ul>
  </div>
  <!-- Sidebar -->
</template>

<style scoped>
.override-parent {
  letter-spacing: 0.05em;
  font-size: 11px !important;
  text-transform: uppercase;
  color: #6a7187 !important;
  font-weight: 600;
}
</style>